import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformTokenV2Response } from './transformers.js';
import defaultClient from 'axios';

const getAuthCheck = async ({ client , controller , token  } = {})=>await client.get('/V1/auth/check', {
        signal: controller?.signal,
        headers: {
            ...token ? {
                oauth_consumer_token: token
            } : {}
        }
    });
getAuthCheck.key = 'getAuthCheck';
const postAuthInitV2 = async ({ client , controller  } = {})=>await client.post('/V2/auth/init', null, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformTokenV2Response)
        ]
    });
postAuthInitV2.key = 'postAuthInitV2';
const getAuthRefreshV2 = async ({ client , controller , token  } = {})=>await client.get('/V2/auth/refresh', {
        signal: controller?.signal,
        headers: {
            ...token ? {
                oauth_consumer_token: token
            } : {}
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformTokenV2Response)
        ]
    });
getAuthRefreshV2.key = 'getAuthRefreshV2';
const postAuthSessionCleanV2 = async ({ client , controller  } = {})=>await client.post('/V2/auth/session/clean', null, {
        signal: controller?.signal
    });
postAuthSessionCleanV2.key = 'postAuthSessionCleanV2';

export { getAuthCheck, getAuthRefreshV2, postAuthInitV2, postAuthSessionCleanV2 };
